import { EyeOutlined } from '@ant-design/icons';
import { Button, Card, Descriptions, Flex, Tag, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const renderText = (value) => value || '-';
const renderManagerNames = (managerNames) =>
  Array.isArray(managerNames) && managerNames.length ? managerNames.join('、') : '-';

const StoreDirectoryCard = ({ store, to }) => (
  <Card
    data-testid="store-directory-card"
    title={
      <Flex align="center" gap="small" wrap>
        <Typography.Text strong>{store.name}</Typography.Text>
        {!store.enabled && <Tag>停用</Tag>}
      </Flex>
    }
    extra={
      <Link to={to}>
        <Button icon={<EyeOutlined />} type="link">
          查看360视图
        </Button>
      </Link>
    }
    variant="outlined"
  >
    <Descriptions
      size="small"
      column={1}
      items={[
        { key: 'code', label: '编码', children: renderText(store.code) },
        {
          key: 'parent',
          label: '区域',
          children: renderText(store.operationEntityParentName),
        },
        {
          key: 'managerNames',
          label: '店长',
          children: renderManagerNames(store.managerNames),
        },
        {
          key: 'inventoryManagerName',
          label: '库管',
          children: renderText(store.inventoryManagerName),
        },
        { key: 'businessFormat', label: '业态', children: renderText(store.businessFormat) },
        {
          key: 'businessStatus',
          label: '状态',
          children: renderText(store.businessStatus),
        },
        {
          key: 'area',
          label: '面积',
          children: store.area === null || store.area === undefined ? '-' : `${store.area} ㎡`,
        },
        { key: 'openedAt', label: '开业', children: renderText(store.openedAt) },
        { key: 'address', label: '地址', children: renderText(store.businessAddress) },
      ]}
    />
  </Card>
);

StoreDirectoryCard.propTypes = {
  store: PropTypes.shape({
    businessAddress: PropTypes.string,
    businessFormat: PropTypes.string,
    businessStatus: PropTypes.string,
    area: PropTypes.number,
    code: PropTypes.string.isRequired,
    enabled: PropTypes.bool.isRequired,
    inventoryManagerName: PropTypes.string,
    managerNames: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string.isRequired,
    operationEntityParentName: PropTypes.string,
    openedAt: PropTypes.string,
  }).isRequired,
  to: PropTypes.string.isRequired,
};

export default StoreDirectoryCard;
